import { memo } from 'react';
import { useTranslation } from 'react-i18next';

import { StationMetrics } from '../../../services/ocpp/types';
import { formatNumber } from '../../../shared/utils/numberFormat';
import { MASK } from '../../../shared/utils/mask';

interface MobileStationMetricsProps {
  metrics: StationMetrics[];
  loading: boolean;
  /** Hide mode: renders every figure as a mask. */
  hidden?: boolean;
}

export const MobileStationMetrics = memo(function MobileStationMetrics({
  metrics,
  loading,
  hidden = false,
}: MobileStationMetricsProps) {
  const { t } = useTranslation();

  if (loading) {
    return (
      <div className="mobile-station-metrics">
        <div className="skeleton" style={{ height: '120px', borderRadius: '0.75rem' }} />
        <div className="skeleton" style={{ height: '120px', borderRadius: '0.75rem' }} />
      </div>
    );
  }

  if (metrics.length === 0) {
    return null;
  }

  return (
    <div className="mobile-station-metrics">
      {metrics.map((station) => (
        <div key={station.stationId} className="mobile-station-metric-card">
          <div className="mobile-station-metric-header">
            {station.address || station.idTag}
          </div>
          <div className="mobile-station-metric-grid">
            <div className="mobile-station-metric-item">
              <span className="mobile-station-metric-label">{t('dashboard.metrics.tableSessions')}</span>
              <span className="mobile-station-metric-value" style={{ fontVariantNumeric: 'tabular-nums' }}>{station.sessionCount}</span>
            </div>
            <div className="mobile-station-metric-item">
              <span className="mobile-station-metric-label">{t('dashboard.metrics.energyMobile')}</span>
              <span className="mobile-station-metric-value" style={{ fontVariantNumeric: 'tabular-nums' }}>{hidden ? MASK : formatNumber(station.kwh)} {t('dashboard.metrics.kwh')}</span>
            </div>
            <div className="mobile-station-metric-item">
              <span className="mobile-station-metric-label">{t('dashboard.metrics.revenueMobile')}</span>
              <span className="mobile-station-metric-value" style={{ fontVariantNumeric: 'tabular-nums' }}>{hidden ? MASK : formatNumber(station.revenue)} {t('dashboard.metrics.uah')}</span>
            </div>
            <div className="mobile-station-metric-item">
              <span className="mobile-station-metric-label">{t('dashboard.metrics.idleRevenueMobile')}</span>
              <span className="mobile-station-metric-value" style={{ fontVariantNumeric: 'tabular-nums' }}>{hidden ? MASK : formatNumber(station.idleRevenue ?? 0)} {t('dashboard.metrics.uah')}</span>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
});

export default MobileStationMetrics;
